<template>
    <div id="TopicsRev" >
        
      <div id="lda" v-if="datum">
        <h3 class="rowtitle">❇️AI generated topic list</h3> 
        <p>All reviews can be defined with these topics. (Experimental)</p>
      <p  v-html="datum.summary"></p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        datum: null
      }
    },
    props: {
        company: String,
        revsite: String
    },
    created() {
      this.fetchText()  
    },
  
    methods: {
       fetchText() {
        try {

            this.datum = require(`@/assets/analytics/${this.revsite}/${this.company}_lda.json`);
        } catch (e) {
            console.log(e)
            this.datum = null
        }

      }
    }
  }
  </script>
  
  <style scoped>
  p {
    white-space: pre-wrap;
    font-size: small;
  }  
#lda {

    border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(to bottom right, #ffffff, #e0e0e0);
  padding: 20px;
  margin: 10px;
}

.badge {
    float: left;
    padding: 8px 16px;
    background-color: #007bff;
    color: #fff;
    font-family: 'Arial', sans-serif;
    font-size: 10px;
    font-weight: bold;
    border-radius: 4px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
  
  </style>